import type React from 'react'
import ReactDOM from 'react-dom'

import { getRoot } from 'utils/portal'

const PORTAL_ROOT_ID = 'app-portal'

type TetherPortalProps = {
  children?: React.ReactNode
  isOpen?: boolean
}

export const TetherPortal = ({
  children,
  isOpen = false,
}: TetherPortalProps) => {
  const root = isOpen ? getRoot(PORTAL_ROOT_ID) : null

  if (!root) return null

  return ReactDOM.createPortal(children, root)
}
